export default __webpack_public_path__ + "static/media/sentimentIndexWidget.453dbadc.png";